import FooterNavbar from "../../../footernavbar/FooterNavbar";
import OurWorkplaceNavbar from "./OurWorkplaceNavbar";

const OurEmployees = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <OurWorkplaceNavbar />
        <div className="py-3">
          <div className="mt-3">
            <div className="row">
              <div className="container">
                <div className="col-lg-12 justify-content-center text-center ">
                  <span className="badge rounded-pill badge-warning text-white text-capitalize mb-2">
                    Our Employees
                  </span>
                  <h1 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-l text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    The Heart of Sworld solutions private limited
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-r text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h1>
                </div>
              </div>
            </div>
            <div className="w-60 h-50 mx-auto mt-4">
              <div className="d-block blur-shadow-image">
                <img
                  src="https://i3.wp.com/circaworks.com/wp-content/uploads/2020/12/what-makes-a-good-team.jpg?ssl=1"
                  alt="img-blur-shadow-blog-2"
                  className="img-full "
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="row w-70 d-flex justify-content-center mx-auto pt-0">
            <section className="py-5">
              <div className="container">
                <div className="row">
                  <div className="row align-items-center">
                    <div className="container col-lg-12  col-md-6 position-relative mb-sm-0 mb-3">
                      <h1 className="mb-3 text-black text-center fw-bold">
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Our Employees{" "}
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                      <p className="mb-3 fs-4 container text-black">
                        At Sworld solutions private limited, we believe that our
                        employees are the cornerstone of our success. Their
                        dedication, creativity, and passion drive our company
                        forward, helping us to innovate and deliver exceptional
                        products and services to our customers. We are proud to
                        have a team that is not only talented but also diverse,
                        collaborative, and committed to our shared vision.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center py-7">
                    <div className="mb-3">
                      <h3 className="mb-3 text-black fw-bold">
                        1. A Talented and Diverse Team :
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        Our team is made up of individuals from a wide range of
                        backgrounds, each bringing unique perspectives and
                        skills to the table. This diversity fuels our creativity
                        and innovation, allowing us to tackle challenges from
                        multiple angles and develop solutions that resonate with
                        our global customer base. We are committed to fostering
                        an inclusive environment where everyone feels valued and
                        empowered to contribute their best work.
                      </p>
                    </div>
                    <div>
                      <h3 className="mb-3 text-black fw-bold ">
                        2. Collaboration and Teamwork :
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        At Sworld solutions private limited, we understand that
                        collaboration is key to our success. We promote a
                        culture of teamwork, where open communication and mutual
                        respect are paramount. By working together, we can
                        leverage our collective strengths and achieve more than
                        we ever could individually. Our collaborative spirit
                        extends beyond our internal team to our interactions
                        with customers, suppliers, and partners, ensuring that
                        we build strong, mutually beneficial relationships.
                      </p>
                    </div>
                    <div>
                      <h3 className="mb-3 text-black fw-bold ">
                        3. Wellness Programs :
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        Our wellness programs include gym memberships, fitness
                        classNamees, and health workshops to encourage a healthy
                        and active lifestyle. We also offer regular health
                        screenings and flu shots to keep our team in top
                        condition.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                    <img
                      className="w-100 border-radius-lg shadow"
                      src="../../assets/img/footer/employee-2.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="py-0">
              <div className="container">
                <div className="row">
                  <h2 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-l text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    Employees who feel valued will always deliver more than what
                    is expected.
                    <sup>
                      <i
                        className="ri-double-quotes-r text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h2>
                  <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                    <img
                      className="w-100 border-radius-lg shadow"
                      src="../../assets/img/footer/employee-1.jpg"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6 col-10 d-flex justify-content-center flex-column mx-auto text-lg-start text-center">
                    <div className="mb-3">
                      <h3 className="mb-3 text-black fw-bold">
                        1. Employee Growth and Development :
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        We are dedicated to the growth and development of our
                        employees. We believe that investing in our team is
                        essential for our long-term success. To support this, we
                        offer a variety of training and development programs,
                        mentorship opportunities, and clear career advancement
                        paths. Whether it's through professional development
                        workshops, online courses, or on-the-job training, we
                        provide our employees with the resources they need to
                        thrive and grow in their careers.
                      </p>
                    </div>
                    <div>
                      <h3 className="mb-3 text-black fw-bold ">
                        2. A Culture of Innovation
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        Innovation is at the heart of everything we do at Sworld
                        solutions private limited. We encourage our employees to
                        think creatively, take risks, and challenge the status
                        quo. By fostering a culture of innovation, we empower
                        our team to develop cutting-edge solutions and stay
                        ahead of industry trends. This forward-thinking mindset
                        not only drives our business success but also creates an
                        exciting and dynamic workplace where new ideas can
                        flourish.
                      </p>
                    </div>
                    <div>
                      <h3 className="mb-3 text-black fw-bold ">
                        3. Recognition and Rewards
                      </h3>
                      <p className="mb-3 fs-5 container text-black">
                        We believe in recognizing and rewarding the hard work
                        and achievements of our employees. From regular
                        performance reviews to employee appreciation events, we
                        celebrate the contributions of our team members and
                        ensure they feel valued and appreciated. Our
                        comprehensive benefits package, competitive salaries,
                        and performance-based bonuses reflect our commitment to
                        supporting our employees' well-being and success. Our
                        Commitment to a Positive Workplace.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section className="py-6 w-100 mx-auto">
            <div className="row">
              <div className="container">
                <div className="col-lg-12 justify-content-center text-center ">
                  <h1 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-l text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    An employee: the heartbeat of innovation and dedication.
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-r text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h1>
                  <h4 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-l text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    At Sworld solutions private limited, we are committed to
                    creating a positive and supportive workplace where our
                    employees can thrive. <br /> We prioritize work-life
                    balance, offering flexible work arrangements and wellness
                    programs to support our team's overall health and happiness.{" "}
                    <br /> By maintaining a positive work environment, we ensure
                    that our employees are motivated, engaged, and ready to
                    deliver their best work every day.{" "}
                    <sup>
                      <i
                        className="ri-double-quotes-r text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h4>
                </div>
              </div>
            </div>
            <div className="w-60 h-50 mx-auto mt-4">
              <div className="d-block blur-shadow-image">
                <img
                  src="../../assets/img/footer/employee-4.jpg"
                  alt="img-blur-shadow-blog-2"
                  className="img-full "
                  loading="lazy"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default OurEmployees;
